import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledHeader = styled.div<{
  $isTransparent: boolean;
  $showBanner: boolean;
  $headerDisplayNone: boolean;
  $stickToTop: boolean;
}>`
  display: ${({ $headerDisplayNone }) => ($headerDisplayNone ? 'none' : 'block')};

  header {
    top: ${({ $showBanner, $isTransparent, $stickToTop }) => {
      if (!$stickToTop) {
        return 'auto';
      }

      return $showBanner && $isTransparent ? '40rem' : '0';
    }};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    header {
      top: ${({ $showBanner, $isTransparent, $stickToTop }) => {
        if (!$stickToTop) {
          return 'auto';
        }

        return $showBanner && $isTransparent ? '33rem' : '0';
      }};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    header {
      top: ${({ $showBanner, $isTransparent, $stickToTop }) => {
        if (!$stickToTop) {
          return 'auto';
        }
        return $showBanner && $isTransparent ? '39rem' : '0';
      }};
    }
  }
`;

export const StyledTableTopIcon = styled(FontAwesomeIcon)`
  margin-right: 0.6rem;
  transform: scale(1.25);
  stroke: ${({ theme }) => theme.colors.white};

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    margin-right: 0.6rem;
  }
`;
